module.exports = __webpack_public_path__ + "static/media/sa8.4bd962a8.jpg";